import * as Application from 'expo-application';
import { Platform } from 'react-native';

import { uuid } from '../common/misc';
import { captureException } from '../logger/Logger';

export const getDeviceId = async (): Promise<string> => {
    let deviceId: string | null = null;

    if (Platform.OS === 'android') {
        deviceId = Application.getAndroidId();
    } else if (Platform.OS === 'ios') {
        deviceId = await Application.getIosIdForVendorAsync();
    }

    if (deviceId === null) {
        captureException(new Error(`Failed to get device id.`), {
            platform: Platform.OS,
        });

        // TODO - Persist the uuid to local storage so that it is consistent across app restarts.
        deviceId = uuid();
    }

    return deviceId;
};
